import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import LoanService from "../../../../../services/LoanService";

const ApproveModal = ({ modal, setModal, item, setShouldUpdate }) => {
	const [note, setNote] = useState("");
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);

	const handleApprove = () => {
		setLoading(true);
		new LoanService()
			.approve(item.id, { note })
			.then((res) => {
				if (res?.status === 200 || res?.status === 201) {
					toast.success(Translate[lang]?.updated_successfully);
					setShouldUpdate((prev) => !prev);
					setModal();
				}
			})
			.finally(() => setLoading(false));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={setModal}>
			<Modal.Header>
				<Modal.Title>{Translate[lang]?.approve}</Modal.Title>
				<Button
					variant=""
					className="close"
					style={{
						right: lang === "en" ? "0" : "auto",
						left: lang === "ar" ? "0" : "auto",
					}}
					onClick={setModal}>
					<span>&times;</span>
				</Button>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<Col md={12} className="mb-3">
						<label className="text-label">{Translate[lang]?.note}</label>
						<textarea
							className="form-control"
							rows={3}
							value={note}
							onChange={(e) => setNote(e.target.value)}
						/>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={setModal} variant="danger light">
					{Translate[lang]?.close}
				</Button>
				<Button variant="primary" onClick={handleApprove} disabled={loading}>
					{loading ? (
						<span className="spinner-border spinner-border-sm" />
					) : (
						Translate[lang]?.approve
					)}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ApproveModal;
